













import { Component, Vue } from 'vue-property-decorator'
import { TagsViewModule } from '@/store/modules/tags-view'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'AppMain'
})
export default class extends Vue {
  mounted() {
    this.watermark()
  }
  // 水印
  watermark() {
    const content = UserModule.name
    const time = new Date()
    const currentTime =
      time.getFullYear() + '.' + (time.getMonth() + 1) + '.' + time.getDate()
    this.$watermark.set(
      content ? content + '(' + currentTime + ')' : '用户名不存在'
    )
  }
  get cachedViews() {
    let ret: any = ['SubLayout']
    ret = ret.concat(TagsViewModule.cachedViews)
    // console.log(ret)
    return ret
  }

  get key() {
    return this.$route.path
  }
}
